import { safeHttpUrl } from '../lib/safeUrl.js'
import './adOriginCard.css'

const CHANNEL_LABEL = {
  click_to_whatsapp: 'Veio de anúncio (Click-to-WhatsApp)',
  lead_ads: 'Veio de anúncio (formulário Lead Ads)',
}

/**
 * Anúncio da Meta que gerou o contato: referral da primeira mensagem
 * (Click-to-WhatsApp) ou formulário de Lead Ads. `origin` vem de `ad_origin`
 * em GET /api/crm/contacts/{id}.
 */
export default function AdOriginCard({ origin }) {
  if (!origin) return null
  const title = origin.ad_name || origin.headline || (origin.source_id ? `Anúncio ${origin.source_id}` : 'Anúncio da Meta')
  const safeUrl = safeHttpUrl(origin.source_url)
  return (
    <div className="ad-origin">
      {origin.thumbnail_url && /^https?:\/\//i.test(origin.thumbnail_url) && (
        <img src={origin.thumbnail_url} alt="" loading="lazy" />
      )}
      <div>
        <span className="ad-origin-label">{CHANNEL_LABEL[origin.channel] || 'Veio de anúncio da Meta'}</span>
        <strong>{title}</strong>
        {origin.campaign_name && <small>Campanha: {origin.campaign_name}</small>}
        {origin.adset_name && <small>Conjunto: {origin.adset_name}</small>}
        {(origin.form_name || origin.form_id) && <small>Formulário: {origin.form_name || origin.form_id}</small>}
        {safeUrl && <a href={safeUrl} target="_blank" rel="noopener noreferrer">Abrir anúncio</a>}
      </div>
    </div>
  )
}
